import registerTableObjectDirectives from "./table";
import registerCmsPreferenceCheckboxDirective from './helpers/CMSPreferenceCheckboxDirective';
import registerAsfContentObjectHeaderDirective from './helpers/CMSContentObjectHeader';
import registerPartialObjectDirective from './PartialObjectDirective';
import { registerAsfTextObjectDirective, registerAsfTextmcqObjectDirective} from './TextObjectDirective';
import registerAsfWirisObjectDirective from './WirisObjectDirective';
import registerAsfGeoGebraObjectDirective from './GeoGebraObjectDirective';
import registerCmsPreferenceTextareaDirective from './helpers/CMSPreferenceTextareaDirective';
import registerCmsPreferenceSelectDirective from './helpers/CMSPreferenceSelectDirective';
import registerIframeObjectDirective from './IframeObjectDirective';
import UniversalCanvasMediaBrowserModalController from './modalCtrl/UniversalCanvasMediaBrowserModalController';
import registerAsfScattergraphObjectDirective from './ScatterGraphObjectDirective';
import registerCmsPreferenceSelectOtherContentObjectDirective from './helpers/CMSPreferenceSelectOtherContentObjectDirective';
import registerAsfImageObjectDirective from './ImageObjectDirective';
import registerAsfVideoObjectDirective from './VideoObjectDirective';
import registerAsfAudioObjectDirective from './AudioObjectDirective';
import registerContentObjectDirective from './ContentObjectDirective';
import registerAsfResponseShortTextboxObjectDirective from './ResponseShortTextBoxDirective';
import registerAsfMeasurementObjectDirective from './MeasurementObjectDirective';
import registerAutoPlotFromTableObjectDirective from './AutoPlotFromTableObjectDirective';
import registerAsfResponseTextboxObjectDirective from './ResponseTextBoxDirective';
import registerCmsPreferenceMultiselectDirective from './helpers/CMSPreferenceMultiselectDirective';
import registerCmsPreferenceColorpickerDirective from './helpers/CMSPreferenceColorpickerDirective';
import registerCmsPreferenceDirective from './helpers/CMSPreferenceDirective';
import registerCmsPreferenceInputDirective from './helpers/CMSPreferenceInputDirective';
import registerAsfHintObjectDirective from './HintObjectDirective';
import registerAsfInteractionContainerDirective from './InteractionContainerDirective';
import registerUniversalCanvasObject from './UniversalCanvasObjectDirective';
import BaseObjectDirective from "./BaseObjectDirective";
import { registerAsfTextObjectNewDirective } from './TextObjectDirectiveCK5';
import { registerAsfResponseTextboxObjectNewDirective } from './ResponseTextBoxCK5Directive';

export default function registerContentObjectDirectives(angular) {
    const module = angular.module('assessmentFrontendDirectives');
    
    BaseObjectDirective.registerAutoSaveResponseInputDirective(module);
    registerTableObjectDirectives(angular);
    registerAsfResponseShortTextboxObjectDirective(module);
    registerAsfContentObjectHeaderDirective(module);
    registerCmsPreferenceMultiselectDirective(module);
    registerAutoPlotFromTableObjectDirective(module);
    registerAsfMeasurementObjectDirective(module);
    registerAsfTextObjectDirective(module);
    registerAsfTextmcqObjectDirective(module);
    registerAsfTextObjectNewDirective(module);
    registerAsfResponseTextboxObjectDirective(module);
    registerCmsPreferenceSelectOtherContentObjectDirective(module);
    registerIframeObjectDirective(module);
    registerAsfVideoObjectDirective(module);
    registerCmsPreferenceColorpickerDirective(module);
    registerCmsPreferenceInputDirective(module);
    registerCmsPreferenceTextareaDirective(module);
    registerPartialObjectDirective(module);
    registerContentObjectDirective(module);
    registerCmsPreferenceCheckboxDirective(module);
    registerAsfGeoGebraObjectDirective(module);
    registerCmsPreferenceSelectDirective(module);
    registerAsfScattergraphObjectDirective(module);
    registerAsfWirisObjectDirective(module);
    registerAsfImageObjectDirective(module);
    registerCmsPreferenceDirective(module);
    registerAsfAudioObjectDirective(module);
    registerAsfHintObjectDirective(module);
    registerAsfInteractionContainerDirective(module);
    registerUniversalCanvasObject(module);
    registerAsfResponseTextboxObjectNewDirective(module);
    
    angular.module('assessmentFrontendControllers').controller('UniversalCanvasMediaBrowserModalController', UniversalCanvasMediaBrowserModalController);
}